module.exports = __webpack_public_path__ + "img/sensornode.8aedbc02.svg";